// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3eIAx","title":"FrontImage_title__3vLVv"};